import React from 'react'
import { FontAwesomeIcon } from '@webstollen/react-native/lib/fontawesome'
import getOrderStatusIcon, { OrderStatusType } from './get-order-status-icon'

const OrderStatusIcon = ({ status }: { status: OrderStatusType }) => (
  <FontAwesomeIcon color={'white'} icon={getOrderStatusIcon(status)} />
)

export default OrderStatusIcon
